import { useEventCallback } from '@ixigo/iui/utils';
import { useLogin as useLoginOriginal } from '@ixigo-packages/login';
import { useAppContext } from './useAppContext';

type UseLoginOptions = Parameters<typeof useLoginOriginal>[0];

export function useLogin(options?: UseLoginOptions) {
	const res = useLoginOriginal(options);

	const context = useAppContext();

	const triggerLogin: typeof res.triggerLogin = useEventCallback(
		(onLogin, onError) => {
			return res.triggerLogin((res) => {
				if (context) {
					context.cookie.syncCookies();
				}
				return onLogin?.(res);
			}, onError);
		},
	);

	return {
		...res,
		triggerLogin,
	} satisfies typeof res;
}
